import { useCallback } from 'react';

import useProject from 'hooks/useProject';
import { hasFeatureAccess } from 'lib/featuresHelper';
import type { ProjectResource } from '.';
import { useProjectResources } from './useProjectResources';

export const useProjectResource = () => {
  const {
    features,
    restrictedFeatures,
    isFetchingProjectFeatures,
    didProjectFeaturesError,
    isResourceReadOnly,
  } = useProjectResources();
  const { project } = useProject();

  const isProjectResourceEnabled = useCallback(
    (resource: ProjectResource) => {
      return hasFeatureAccess(
        resource,
        features,
        restrictedFeatures,
        project?.type,
      );
    },
    [features, project?.type, restrictedFeatures],
  );

  const hasProjectResourceWriteAccess = useCallback(
    (resource: ProjectResource) =>
      isProjectResourceEnabled(resource) && !isResourceReadOnly(resource),
    [isProjectResourceEnabled, isResourceReadOnly],
  );

  return {
    isProjectResourceEnabled,
    hasProjectResourceWriteAccess,
    isFetchingProjectFeatures,
    didProjectFeaturesError,
    isResourceReadOnly,
  };
};
